const state = {
    opened: {}
}

if (localStorage.opened) {
    state.opened = JSON.parse(localStorage.opened)
}

const actions = {

}

const mutations = {
    setOpen (state, request) {
        state.opened[request.id] = request.status
        localStorage.opened = JSON.stringify(state.opened)
    }
}

export const tree = {
    namespaced: true,
    state,
    actions,
    mutations
}
